module.exports = __webpack_public_path__ + "media/images/flags/TN-86e683e9f3790d4ed5fa2db150de3a76.svg";